module.exports = {
      id: "dh-symbol-usage",
      viewBox: "0 0 344.84 299.91",
      url: __webpack_public_path__ + "svg-sprite-c71831da97eff2ec188167649c252867.svg#dh-symbol",
      toString: function () {
        return this.url;
      }
    }